/* eslint-disable prettier/prettier */
import React, { Component } from "react";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";
import Button from "@/bit/components/next13.components.button";
import getColor from "@gerenciatd/next13.enums.colors";
import Glyph from "@/bit/components/next13.components.glyph";

const Teletipo = (props) => {
  const { skeletonClassName, custoObjectInfo } = props;
  const background = getColor(props["backgroundColor"]) || getColor("GREY1");
  const taggingInfo = {
    componentVariation: "all",
    componentProduct: "TeletipoButton",
    componentName: "Teletipo",
    eventType: "click",
  };

  let className = 'section-teletipo';

  /* EDITING MODE BEGINS */
  let DetailBar = null;
  if (custoObjectInfo){
    className = `${className} customizer-component`;
    // si ele primer nodo marcarlo
    if (custoObjectInfo.entryPoint === ''){
      className = `${className} custo`;
      DetailBar = custoObjectInfo.components.DetailBar;
    }
  }
  /* EDITING MODE ENDS */

  return (
    <section className={className} data-cy="Section teletipo" >
      {DetailBar}
      <div className="teletipo">
        {props["Glyph-1"] && (
          <Glyph
            id={props["Glyph-1"].id.toLowerCase()}
            kind={props["Glyph-1"].kind}
            width={props["Glyph-1"].width}
            color={props["Glyph-1"].color}
          />
        )}
        <div className="text-gap">
          {props["Text-1"] && (
            <div className="lineinfo-gap">
              <Text {...props["Text-1"]} cyData="Teletipo Text-1" />
            </div>
          )}
        </div>
        {props["CustomLink-1"] && (
          <CustomLink
            taggingInfo={taggingInfo}
            {...props["CustomLink-1"]}
            cyData="Teletipo CustomLink-1"
          />
        )}
        {props["Button-1"] && (
          <div className="blue-button">
            <Button {...props["Button-1"]} cyData="Teletipo Button-1" />
          </div>
        )}
      </div>
      <div className={skeletonClassName} />
      <style jsx>
        {`
          .section-teletipo {
            position: relative;
            background-color: ${background};
            .teletipo {
              display: flex;
              position: relative;
              align-items: center;
              justify-content: center;
              gap: 1rem;
              height: 56px;
              :global(.teletipo-button) {
                background-color: transparent !important;
                border-color: transparent !important;
              }
              :global(.svg-layout-size) {
                overflow: visible;
              }
              @media screen and (max-width: 768px) {
                padding: 0.75rem;
                gap: 0.3rem;
              }
              @media screen and (max-width: 368px) {                
                .text-gap {
                  width: 85%;
                }
              }
            }
          }
        `}
      </style>
    </section>
  );
};

export default Teletipo;
